import React, { useEffect } from "react";
import './../css/aboutus.css';
import PageBreadcrumbs from "./../SharedComponent/page-breadcrumbs";
import missionImg from "./../assets/images/mission.webp";
import visionImg from "./../assets/images/vision.webp";
import servicesImg from "./../assets/images/services/1.webp";

const AboutUsPage = () => {
  useEffect(() => {
    document.title = "About Us | PS Environmental Services Inc.";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageBreadcrumbs
        title="About Us"
        subtitle="Who We Are"
        breadcrumbs={{
          currentPage: "About Us",
          items: [{ name: "Home", href: "/" }],
        }}
      />
       <div className="aboutus-page">
        
        {/* Company Overview */}
        <section className="py-10 px-10 company-overview">
          <p className="me-1">
            At <strong className="strong-text">PS Environmental Services Inc.</strong>, we specialize in
            one thing: keeping industrial air pollution control systems running at
            peak performance.
          </p>
          <p>
            Since our founding in <strong className="strong-text">1981</strong>, we have built a reputation for expertise, responsiveness, and integrity in a highly specialized field. From routine maintenance to complex baghouse rebuilds and 24/7 emergency service, we support manufacturers, utilities, foundries, and processing plants across the country.
          </p>
          <p>
            What sets us apart is more than our technical knowledge. It is our relentless focus on reducing downtime, extending equipment life, and keeping your operations compliant and productive. Our team brings decades of hands-on experience and field-tested solutions to every job, whether it is a scheduled shutdown or a last-minute callout.
          </p>
          <p>
            We do not just service dust collection systems. We help clients breathe easier, meet regulatory standards, and avoid costly interruptions
          </p>
          <p className="fs-5 count-on-text">
            PS Environmental Services Inc. delivers air system reliability you can count on.
          </p>
        </section>
  
        <section className="mission-vision">
          <div className="fs-1 fw-bold mb-4">Our mission & vision.</div>
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="overflow-hidden mb-3 img-border-radius" style={{ height: '16rem'}}>
                <img
                  src={missionImg}
                  alt="Mission"
                  className="img-fluid w-100 h-100 object-fit-cover"
                  style={{ height: '16rem' }}
                />
              </div>
              <div className="mt-3 mission-text">
                <div className="fs-5 mb-2 ">Mission</div>
                <p>
                  We are committed to providing dependable, expert service that helps
                  your operation maintain compliance, performance, and uptime—all
                  while ensuring economic feasibility.
                </p>
              </div>
            </div>
  
            <div className="col-md-6">
              <div className="img-border-radius overflow-hidden mb-3" style={{ height: '16rem' }}>
                <img
                  src={visionImg}
                  alt="Vision"
                  className="img-fluid w-100 h-100 object-fit-cover"
                  style={{ height: '16rem' }}
                />
              </div>
              <div className="mt-3 vision-text">
                <div className="fs-4 mb-2">Vision</div>
                <p>
                  To lead the industry in air pollution control by delivering innovative, reliable, and sustainable baghouse solutions—protecting companies and the environment and empowering cleaner industries.
                </p>
              </div>
            </div>
          </div>
        </section>
  
        {/* What We Do Best */}
        <section className="what-we-do-best">
          <div className="row align-items-center">
            <div className="col-md-6 mb-md-0">
              <h2 className="what-we-do-title">
                What We Do Best
              </h2>
              <p className="our-team-services-text">
                Our team is trained and equipped to support a wide range of
                industries with tailored dust collection and filtration services,
                including:
              </p>
              <ul className="list-of-services">
                <li>
                  <strong>System Design Corrections</strong> – Re-engineering or
                  modifying existing systems
                </li>
                <li>
                  <strong>Airflow Optimization</strong> – Ductwork balancing and
                  airflow studies
                </li>
                <li>
                  <strong>Start-Up & Operating Procedures</strong> – Development
                  and implementation
                </li>
                <li>
                  <strong>Routine Inspections</strong> – Monthly, quarterly, or
                  annual evaluations
                </li>
                <li>
                  <strong>Troubleshooting & Diagnostics</strong> – Fast
                  identification of system issues
                </li>
                <li>
                  <strong>Maintenance & Repairs</strong> – Bag change-outs,
                  mechanical service, cleaning systems
                </li>
                <li>
                  <strong>Fabric Selection Expertise</strong> – 30+ years advising
                  on application-specific fabrics
                </li>
                <li>
                  <strong>Filter Bags & Parts Supply</strong> – Extensive
                  inventory for fast delivery
                </li>
                <li>
                  <strong>Safety Certifications</strong> – Qualified to work in
                  hazardous environments
                </li>
                <li>
                  <strong>Training Seminars</strong> – On-site or remote education
                  on dust collector operations
                </li>
                <li>
                  <strong>Preventive Maintenance Programs</strong> – Custom PM
                  services for baghouse systems
                </li>
              </ul>
            </div>
  
            <div className="col-md-6">
              <img
                src={servicesImg}
                alt="Our Services"
                className="img-fluid rounded shadow w-100"
              />
            </div>
          </div>
        </section>
  
        {/* Industries We Serve */}
        <section className="bg-white industries-we-serve">
          <div>
            <h2 className="fs-1 fw-semi-bold text-dark mb-3">Industries We Serve</h2>
            <ul className="row list-unstyled industries-list">
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> General Manufacturing industry
              </li>
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> Food Processing industry
              </li>
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> Woodworking
              </li>
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> Chemical industry
              </li>
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> Aerospace industry
              </li>
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> Semiconductor and Defense industry
              </li>
              <li className="col-12 col-sm-6 mb-2 d-flex align-items-center gap-2">
                <span className="text-primary fw-bold">✓</span> Recycling
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
   
  );
};

export default AboutUsPage;